import React from "react";

function ProductDetailsLeft() {
  return (
    <>
      <div className="card mb-3">
        <img
          className="card-img img-fluid"
          src={
            "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
          }
          alt="Card imagecap"
          id="product-detail"
        />
      </div>
      <div className="row">
        <div className="col-1 align-self-center">
          <a href="#multi-item-example" role="button" data-bs-slide="prev">
            <i className="text-dark fas fa-chevron-left"></i>
            <span className="sr-only">Previous</span>
          </a>
        </div>

        <div
          id="multi-item-example"
          className="col-10 carousel slide carousel-multi-item"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner product-links-wap" role="listbox">
            <div className="carousel-item active">
              <div className="row">
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className="row">
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className="row">
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="card-img img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="Product_Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-1 align-self-center">
          <a href="#multi-item-example" role="button" data-bs-slide="next">
            <i className="text-dark fas fa-chevron-right"></i>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    </>
  );
}

export default ProductDetailsLeft;
